<template>
  <div v-if="showTitle || canAddCall || $slots['title-actions'] || $slots.actions" class="calls-header">
    <h3 v-if="showTitle">
      <i class="fas fa-phone"></i> Appels
      <slot name="title-actions"></slot>
    </h3>
    <div class="calls-header-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup>
import { Button } from '../ui'

const props = defineProps({
  showTitle: {
    type: Boolean,
    default: true
  },
  canAddCall: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['add-call'])
</script>

<style scoped>
.calls-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--spacing-md);
  gap: var(--spacing-md);
}

.calls-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: 1;
  color: var(--color-text-primary);
}

.calls-header-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.calls-header h3 i {
  font-size: 1.1rem;
}

.btn-full-width {
  width: 100%;
  justify-content: center;
}

@media (max-width: 768px) {
  .calls-header h3 {
    font-size: 1.1rem;
  }
}
</style>

